import React, { Component } from "react";
import Select from "../common/Select";
import TimeInput from "../common/Time-input";
import Input from "../common/Input";
import close from "../assets/close.svg";
import PictureUpload from "../common/PictureUpload";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";
import Modal from "react-modal";

const mapStateToProps = (state) => ({
  business: state.business,
  headers: state.headers(),
  businessCatergories: state.businessCatergories,
  businesslocationTypes: state.businesslocationTypes,
  locations: state.locations,
  countries: state.countries,
  postOptions: state.postOptions,
  opening_hours: state.opening_hours,
  token: state.token,

});

export default connect(mapStateToProps)(
  class Onboarding extends Component {
    state = {
      active_form: 1,
      cities: [],
      reason: "",
      isDeleteOpen: false,
      deleting: false,
      errors: {},
      openHours: {},
      locationTypeIsPhysical:
        this.props.business.location_type === "Physical Location",
      timeModalIsOpen: false,
    };

    addTime = (ev) => {
      ev.preventDefault();
    };
    close_open = (ev) => {
      this.setState({ timeModalIsOpen: !this.state.timeModalIsOpen });
    };


    save = (ev) => {
      ev.preventDefault();

      this.setState({ loading: true, errors: {} });

      const form = ev.currentTarget;
      const formData = new FormData();

      // get the logo file input
      const logoInput = form.logo;
      const logoFile = logoInput && logoInput.files && logoInput.files[0];
      if (logoFile) {
        console.log(logoFile);
        formData.append("logo", logoFile);
      }

      // append other simple fields
      formData.append("username", form.username.value);
      formData.append("name", form.name.value);
      formData.append("email", form.email.value);
      formData.append("phone_number", form.phone_number.value);
      formData.append("business_type", form.business_type.value);
      formData.append("location_type", form.location_type.value);
      if (form.address?.value?.trim()) {
        formData.append("address", form.address.value.trim());
      }
      formData.append("city", form.city?.value ?? "");
      formData.append("state", form.state?.value ?? "");
      formData.append("country", form.country?.value ?? "");

      // build opening_hours array
      const opening_hours = [];
      Object.keys(this.state.openHours).forEach((key) => {
        if (this.state.openHours[key] !== false) {
          this.state.openHours[key].forEach((hour) => {
            opening_hours.push({
              week_day: key[0].toLocaleUpperCase() + key.slice(1),
              opening_time: hour.from === "00:00" ? "09:00" : hour.from,
              closing_time: hour.to === "00:00" ? "17:00" : hour.to,
            });
          });
        }
      });

      // append opening_hours as JSON
      formData.append("opening_hours", JSON.stringify(opening_hours));
      formData.append("_method", "put");

      // send request
      API({
        method: "POST",         // PUT with FormData often fails in some setups, you might need POST
        url: "business",
        headers: {
          ...this.props.headers,
          Accept: "*/*"
          // Note: DO NOT set 'Content-Type' manually; let browser set it to multipart/form-data
        },
        data: formData,
        transformRequest: [(data) => data]
      })
        .then(
          ({ data }) => {
            if (data.success) {
              window.$.notify("Business settings updated", "success-alert");
            }
          },
          ({ response }) => {
            if (response?.data?.errors) {
              const errors = {};
              response.data.errors.forEach((error) => {
                errors[error.field] = error.message;
              });
              this.setState({ errors });
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });
    };


    rebuildOpeningBuildHours = () => {

      let result = [];
      Object.keys(this.state.openHours).map((key) => {
        if (this.state.openHours[key] !== false)
          this.state.openHours[key].map((hour) => {
            result.push({
              week_day: key,
              opening_time: hour.from,
              closing_time: hour.to,
            });
          });
      });
      return result;
    };
    setCities = (city) => {
      if (this.props.locations)
        this.props.locations.map(({ name, cities }) => {
          if (name.toLowerCase() == city.toLowerCase()) {
            this.setState({ cities });
          }
        });
    };
    openHours = () => {

      return Object.keys(this.state.openHours).map((key) =>
        this.state.openHours[key] !== false ? (
          <div className="input-grid-rapper" >
            <p className="label">{key}</p>
            {this.state.openHours[key].map((hour) => (
              <div class="input-grid" style={{ pointerEvents: "none" }}>
                <Input type="text" placeholder="00:00" value={hour.from} />
                <span class="seperator">-</span>
                <Input type="text" placeholder="00:00" value={hour.to} />
              </div>
            ))}
          </div>
        ) : (
          ""
        )
      );
    };
    setOpeningHours = () => {
      let opening_hours_state = {};
      const opening_hours = this.props.business.opening_hours;
      if (opening_hours)
        opening_hours.map((e) => {
          if (!opening_hours_state[e.week_day])
            opening_hours_state[e.week_day] = [];
          opening_hours_state[e.week_day].push({
            from: e.opening_time,
            to: e.closing_time,
          });
        });
      //  
      this.hasSetOpenHours = true;
      this.setState({ openHours: opening_hours_state });
    };
    updateHours = (hoursState) => {

      this.setState({
        openHours: { ...this.state.openHours, ...hoursState },
      });

    };

    handleLocationTypeChange = ({ currentTarget: { value } }) => {
      this.setState({ locationTypeIsPhysical: value === "Physical Location" });
    };

    componentDidUpdate = (prevProps) => {
      prevProps.business.location_type !== this.props.business.location_type &&
        this.setState({
          locationTypeIsPhysical:
            this.props.business.location_type === "Physical Location",
        });
    };


    openDeleteModal = () => {
      this.setState({ isDeleteOpen: true });
    };

    closeDeleteModal = () => {
      this.setState({
        isDeleteOpen: false,
        reason: ""
      });
    };

    handleDeleteConfirm = () => {
      const { reason } = this.state;
      this.deleteBusiness(reason ?? "");
    };


    deleteBusiness = (reason) => {
        const { id } = this.props.match.params;
        console.log(id, reason);
        this.setState({
          isOpen: false,
          reason: "",
          deleting:true
        });

        API.delete(`/business/?delete_reason=${reason}`, { headers: this.props.headers }).then(
          ({ data }) => {
            window.$.notify(data.message, "success-alert");
            this.props.history.push('/login');
          }
        );
    };


    render() {
      let upcomingBookings = this.props.business?.ongoing_appointments ?? 0;
      if (!this.hasSetOpenHours && this.props.business.id) {
        this.setOpeningHours();
      }
      return (
        <div className="onboarding-page">
          <h1 className="form-title dsk flex center">Business information</h1>
          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">
              <BackArrow />
              Business information
            </h1>
            <div className="form-container card">
              <form
                onSubmit={this.save}
                className="restrict"
                encType="multipart/form-data"
              >
                <PictureUpload
                  title="business photo"
                  name="logo"
                  defaultsrc={this.props.business.logo}
                  description="Your business photo will be seen by customers on your booking page."
                />
                <div></div>
                <Input
                  label="business/ contact name"
                  name="name"
                  placeholder="Enter business name"
                  defaultValue={this.props.business.name}
                  error={this.state.errors.name}
                  type="text"
                  required
                />
                <Input
                  label="Username"
                  // disabled="true"
                  name="username"
                  placeholder="Enter username"
                  defaultValue={this.props.business.username}
                  error={this.state.errors.username}
                  type="text"
                  required
                />
                <Input
                  label="business email"
                  type="email"
                  name="email"
                  placeholder="e.g. you@example.com"
                  defaultValue={this.props.business.email}
                  error={this.state.errors.email}
                // required
                />
                <Input
                  label="business phone number"
                  type="number"
                  name="phone_number"
                  placeholder="e.g. 08123456789"
                  defaultValue={this.props.business.phone_number}
                  error={this.state.errors.phone_number}
                // required
                />
                <Select
                  label="Type of Business"
                  type="text"
                  name="business_type"
                  placeholder="Type of Business"
                  error={this.state.errors.business_type}
                  required
                >
                  {this.props.businessCatergories?.map((category) => (
                    <option
                      value={category.name}
                      selected={
                        category.name.toLowerCase() ===
                        this.props.business.business_type?.toLowerCase()
                      }
                    >
                      {category.name}
                    </option>
                  ))}
                </Select>

                <Select
                  label="Where do you handle your services?"
                  type="text"
                  name="location_type"
                  placeholder="Select location type"
                  onChange={this.handleLocationTypeChange}
                  error={this.state.errors.location_type}
                  required
                >
                  {this.props.businesslocationTypes?.map((type) => (
                    <option value={type.name}

                      selected={
                        type.name ===
                        this.props.business.location_type
                      }
                    >{type.name}</option>
                  ))}
                </Select>

                {this.state.locationTypeIsPhysical && (
                  <>
                    <Input
                      label="Address"
                      type="text"
                      name="address"
                      placeholder="e.g. 12 Business Street"
                      defaultValue={this.props.business.address}
                      error={this.state.errors.address}
                      required
                    />
                    <div className="input-grid">

                      <Input
                        label="City/Area"
                        type="text"
                        name="city"
                        placeholder="e.g. Lekki"
                        defaultValue={this.props.business.state}

                        dataList={this.state.cities}
                        required
                      />




                      <Input
                        label="state"
                        type="text"
                        placeholder="e.g. Lekki"
                        name="state"
                        dataList={this.props.locations ? this.props.locations : []}
                        onChangeAction={this.setCities}
                        defaultValue={this.props.business.state}
                        error={this.state.errors.state}
                        required
                      />

                    </div>
                  </>
                )}
                <Select
                  label="Country"
                  placeholder="select country"
                  name="country"
                  error={this.state.errors.country}
                  required
                >
                  {this.props.countries.map((country) => (
                    <option
                      value={country.name}
                      // selected={
                      //   this.props.business.country?.toLowerCase() ===
                      //   country.name.toLowerCase()
                      // }
                      selected={true}
                    >
                      {country.name}
                    </option>
                  ))}
                </Select>

                <div></div>
                <div>




                  <br></br>
                  <div className="flex center space-btw">
                    <button
                      className={`default ${this.state.loading ? "loading" : ""
                        }`}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </form>
              <hr className="hr"></hr>
              <div className="deleteSection ">
                <h4>Delete Business Account</h4>
                <p>
                  Deleting your Kindlybook account will also remove your public booking page and revoke access for all team members immediately.
                </p>
                <br></br>

                <div>
                  <button onClick={this.openDeleteModal} className="delete_btn btn btn-danger" type="button">Delete Business Account</button>
                </div>
              </div>
            </div>

            {/* time modal */}
            <div
              className={`time-modal modal ${!this.state.timeModalIsOpen ? "hide" : ""
                }`}
            >
              <button className="close-btn" onClick={this.close_open}>
                <img src={close} alt="" />
              </button>
              <form onSubmit={this.addTime}>
                <TimeInput
                  label="Monday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Tuesday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Wednesday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Thursday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Friday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Saturday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Sunday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
              </form>
            </div>
            {/* end of time modal */}
          </div>


          <Modal
            isOpen={this.state.isDeleteOpen}
            onRequestClose={this.closeDeleteModal}

            className="deleteBusinessModal"
          >
            {upcomingBookings > 0 ?
              <div className="">
                <h3 className="modal-title">ACTION REQUIRED</h3>

                <p className="modal-text-l">
                  We detected <b>{upcomingBookings} upcoming bookings</b> on your calendar.
                </p>
                <p className="modal-text">
                  To protect your clients from unexpected cancellations, this account cannot be deleted automatically. Please contact our support team at
                  {" "}
                  <a className="email" href="mailto:hello@kindlybook.com">hello@kindlybook.com</a> to assist with manual account closure.
                </p>



                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: "40px" }}>
                  <a href="mailto:hello@kindlybook.com"
                    className="delete-btn  btn btndanger"
                  >
                    Contact Support
                  </a>

                  <button className="cancel-btn btn" onClick={this.closeDeleteModal}>
                    Cancel
                  </button>
                </div>
              </div>
              :
              <div className="">
                <h3 className="modal-title">CONFIRM DELETE</h3>

                <p className="modal-text">
                  Are you sure you want to delete this account?<br></br>
                  This action is <strong>NOT reversible.</strong>

                </p>

                <div className="form-group">
                  <label>REASON FOR DELETING (OPTIONAL)</label>
                  <textarea className="form-control"
                    placeholder="Let us know why..."
                    value={this.state.reason}
                    onChange={(e) => this.setState({ reason: e.target.value })}
                  />
                  <br></br>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                  <button
                    className="delete-btn  btn btndanger"
                    // disabled={!this.state.reason.trim()}
                    disabled={this.state.deleting}

                    onClick={this.handleDeleteConfirm}
                  >
                    {this.state.deleting ? "Please wait..." : "Yes, Delete"}
                  </button>

                  <button className="cancel-btn btn" onClick={this.closeDeleteModal}>
                    Cancel
                  </button>
                </div>
              </div>}
          </Modal>
        </div>
      );
    }
  }
);
